import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export default function CodeSample(props) {

  const copyContent = async (string) => {
    try {
      await navigator.clipboard.writeText(string);
      console.log('Content copied to clipboard');
    } catch (err) {
      console.error('Failed to copy: ', err);
      alert('Could not copy to clipboard. Check permissions and try again.', err);
    }
  }

  return (
    <Container fluid className="px-5">
      <SyntaxHighlighter language="javascript" style={docco} className="codebox">
        {props.codeString}
      </SyntaxHighlighter>    
      <Button variant="primary" className="float-end" onClick={() => copyContent(props.codeString)}>Copy to Clipboard</Button>
    </Container>
  );
}


